import React, { useState, useEffect } from 'react';
import { fetchAccount } from '../api/user_account';
import { useSelector
  
 } from 'react-redux';
const AccountDetails = ({ accountId, mini = false }) => {
  const [account, setAccount] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const {user,token,isAuthenticated,isLoading} = useSelector((state) => state.auth);

  useEffect(() => {
    if (!accountId) return;
    console.log("AccountDetails:",accountId);
    const getAccount = async () => {
      try {
        const data = await fetchAccount(accountId);
        setAccount(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    getAccount();
  }, [accountId]);

  if (loading) {
    return (
      <div className="animate-pulse flex items-center justify-center p-4">
        <div className="inline-block h-6 w-6 animate-spin rounded-full border-4 border-blue-500 border-r-transparent"></div>
        <span className="ml-2 text-gray-600">Loading account {accountId}...</span>
      </div>
    );
  }
  
  if (error) {
    return (
      <div className="p-4 bg-red-50 text-red-600 rounded-lg border border-red-200">
        <span className="font-medium">Error:</span> {error}
      </div>
    );
  }
  
  if (!account) {
    return (
      <div className="p-4 bg-gray-50 text-gray-600 rounded-lg border border-gray-200">
        No account details found
      </div>
    );
  }

  if (mini) {
    return (
      <div className="flex items-center gap-3 text-left bg-transparent">
        {/* Company Avatar */}
        <div className="h-9 w-9 rounded-lg bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center text-white text-sm font-bold shadow-md flex-shrink-0">
          {account.business_name ? account.business_name.charAt(0).toUpperCase() : 'A'}
        </div>

        {/* Company Info */}
        <div className="flex flex-col min-w-0">
          <h2 className="font-semibold text-gray-800 text-sm truncate">
            {account.business_name || 'N/A'}
          </h2>
          <div className="flex items-center gap-3 text-[11px] text-gray-500">
            <span className="flex items-center gap-1">
              <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
              <span className="truncate">{account.city}, {account.state}</span>
            </span>
            <span className="flex items-center gap-1">
              <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
              </svg>
              <span>{account.phone || 'N/A'}</span>
            </span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-2xl font-bold text-gray-800">
          {account.business_name || 'N/A'}
        </h2>
        <span className={`px-3 py-1 rounded-full text-sm font-medium
          ${account.active 
            ? 'bg-green-50 text-green-600 border border-green-100' 
            : 'bg-red-50 text-red-600 border border-red-100'}`}>
          {account.active ? 'Active' : 'Inactive'}
        </span>
      </div>

      <div className="grid grid-cols-2 gap-6">
        <div className="space-y-4">
          <InfoItem label="Tax ID" value={account.tax_id} />
          <InfoItem 
            label="Signed Legal" 
            value={account.signed_legal_at 
              ? new Date(account.signed_legal_at).toLocaleDateString() 
              : 'N/A'} 
          />
          <InfoItem label="Email" value={account.email} />
          <InfoItem 
            label="Address" 
            value={`${account.address}, ${account.city}, ${account.state} ${account.zip}`} 
          />
        </div>
        
        <div className="space-y-4">
          <InfoItem label="Phone" value={account.phone} />
          <InfoItem 
            label="Contact Name" 
            value={`${account.first_name} ${account.last_name}`} 
          />
          <InfoItem label="Audit Status" value={account.audit_status} />
        </div>
      </div>
    </div>
  );
};

// Helper component for consistent field display
const InfoItem = ({ label, value }) => (
  <div>
    <dt className="text-sm font-medium text-gray-500">{label}</dt>
    <dd className="mt-1 text-sm text-gray-900">{value || 'N/A'}</dd>
  </div>
);

export default AccountDetails;